import axios from "axios";
import store from "@/store";
import {builderBaseUrl} from "@/main";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";


export default {
    namespaced: true,
    state: {
        histories: [],
        meta: [],
    },
    mutations: {
        setHistories(state, projects) {
            state.histories = projects;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
    },
    actions: {
        setHistories({commit, state}, page = 1) {
            // convert filter items to query string
            const user_id = store.getters['User/getUserId']
            const project_id = store.getters['ProjectAlpha/getProject'].id
            axios.get(`${builderBaseUrl}/project-histories/${project_id}/user/${user_id}?page=${page}`)
                .then((res) => {
                    let data = res.data.data;
                    commit("setHistories", data.data);
                    commit("setMeta", data.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    getters: {
        getHistories: state => state.histories,
        getPagination: state => state.meta,
    },
}